export const ACTION_TYPES = {
	SET_OPEN_SIDE_MENU: 'SET_OPEN_SIDE_MENU',
};
